import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import PopupCard from './PopupCard';
import McqComponent from './McqComponent';

const McqPopUp = ({
  open,
  onClose,
  data
}) => {
  if (!open) return null;

  const question = data?.questionStem || data?.question || '';

  return (
    <PopupCard open={open} onClose={onClose}>
      <Box style={{ padding: '32px' }}>
        <McqComponent
          parentApp="aet"
          chapterTitle={data?.chapterTitle}
          question={question}
          questionNumber={data.questionNumber}
          isFlagged={Boolean(data?.isFlagged)}
          attempts={data?.attempts || 0}
          isShowAttempt={Boolean(data?.isShowAttempt)}
          options={data?.options || []}
          selectedOptions={data?.selectedOptions || []}
        />
      </Box>
    </PopupCard>
  );
};

McqPopUp.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.object
};

McqPopUp.defaultProps = {
  data: null
};

export default McqPopUp;

